import React, { type FC } from "react"

import { SectionTitleSlideTemplate } from "../../SlideTemplates/SectionTitleSlide"

export const AccessibilityTitle: FC = () => (
  <SectionTitleSlideTemplate heading="Accessibility" />
)
